/**
 * Device-level user preferences persisted in the browser.
 * Survives leaving a session and logging out - not tied to session identity.
 */

import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface PreferencesStoreState {
  lastNickname: string | null
  setLastNickname: (name: string) => void
}

export const usePreferencesStore = create<PreferencesStoreState>()(
  persist(
    (set) => ({
      lastNickname: null,

      setLastNickname: (name) => {
        set({ lastNickname: name })
      },
    }),
    {
      name: 'giermek-prefs',
      // Validate on the deserialization boundary - localStorage content is untrusted
      onRehydrateStorage: () => (state) => {
        if (state && typeof state.lastNickname !== 'string') {
          state.lastNickname = null
        }
      },
    }
  )
)
